<section
    [ngStyle]="{
        'background-color': get(imageAndTextRow.image_and_text, 'exxcom_color_picker', ''),
        'background-repeat': 'no-repeat',
        'margin-bottom': get(imageAndTextRow.image_and_text, 'exxcom_color_picker', '').length > 0 ? '24px' : ''
    }"
  >
  @if (!isEmpty(get(imageAndTextRow, 'image_and_text.text_block', ''))) {
    <div class="d-flex flex-row container flex-wrap pb-2 image-text">
      @for (row of get(imageAndTextRow, 'image_and_text.text_block', []); track row) {
        <div class="w-100">
          @if (row.text_block) {
            <div class="w-100" [innerHTML]="get(row, 'text_block', '') | safe: 'html'"></div>
          }
        </div>
      }
    </div>
  }

  @for (row of get(imageAndTextRow, 'image_and_text.image_and_text', []); track row) {
    @if (
      isEmpty(get(imageAndTextRow, 'image_and_text.image_and_text[0].accordion', false)) &&
      isEmpty(get(imageAndTextRow, 'image_and_text.image_and_text[0].button_row', false))
      ) {
      <div
        class="image-text grid partial-grid container"
        [class.image-on-right]="row.style === 'Image on the right'"
        >
        @if (row?.image?.href) {
          <div
            class="g-col-lg-6 g-col-12 d-flex flex-column align-items-center justify-content-center image-container"
            >
            @if (row.enable_image_enlargement != true) {
              <img [src]="getWebpImg(row.image.href)" [alt]="row.image.title" />
            }
            @if (row.enable_image_enlargement == true) {
              <app-image-zoom [image]="row.image.href" [altText]="'test'"></app-image-zoom>
            }
          </div>
        }
        <div
          class="g-col-lg-6 g-col-12 d-flex flex-column justify-content-center text-section"
          >
          @if (row.label) {
            <h5>
              {{ row.label }}
            </h5>
          }
          @if (row.header) {
            <h2>
              {{ row.header }}
            </h2>
          }
          @if (row.text) {
            <div class="raw-html" [innerHTML]="row.text | safe: 'html'"></div>
          }
          @if (get(row, 'link.title', '')) {
            <div class="d-flex flex-row">
              <!-- Marketo Form Button -->
              @if (get(row, 'marketo_form_selection.form_selection', '') !== 'no_form') {
                @if (get(row, 'marketo_form_selection.form_selection', '') == 'default_form') {
                  <button-component
                    data-cy="marketo-form"
                            (click)="
                                solutionID && bootstrapMarketoService.openBootstrapMarketoDialog(solutionID, 'edit', {
                                    title: dataTitle,
                                    url: dataUrl
                                })
                            "
                            [buttonOptions]="{
                                text: get(row, 'link.title', ''),
                                type: 'secondary',
                                iconPosition: 'right',
                                iconName: 'chevron-right',
                                disabled: !solutionID
                            }"
                  ></button-component>
                }
                @if (get(row, 'marketo_form_selection.form_selection', '') == 'other_form') {
                  <button-component
                    data-cy="marketo-form"
                            (click)="
                                get(row, 'marketo_form_selection.marketo_forms.id', '') && bootstrapMarketoService.openBootstrapMarketoDialog(get(row, 'marketo_form_selection.marketo_forms.id', ''), 'edit', {
                                    title: dataTitle,
                                    url: dataUrl
                                })
                            "
                            [buttonOptions]="{
                                text: get(row, 'link.title', ''),
                                type: 'secondary',
                                iconPosition: 'right',
                                iconName: 'chevron-right',
                                disabled: !get(row, 'marketo_form_selection.marketo_forms.id', '')
                            }"
                  ></button-component>
                }
              }
              @if (get(row, 'marketo_form_selection.form_selection', '') == 'no_form' && get(row, 'link.routerLink', '')) {
                <a [routerLink]="get(row, 'link.routerLink', '/')">
                  <button-component
                    data-cy="marketo-form"
                    role="link"
                            [buttonOptions]="{
                                text: get(row, 'link.title', ''),
                                type: 'secondary',
                                iconPosition: 'right',
                                iconName: 'chevron-right',
                                innerTabIndex: -1
                            }"
                  ></button-component>
                </a>
              }
            </div>
          }
        </div>
      </div>
    }
  }

  <!-- Dynamic Image Button Row  -->
  @if (!isEmpty(get(imageAndTextRow, 'image_and_text.image_and_text[0].button_row', false))) {
    <div class="container" id="dynamic-buttons">
      <div class="grid">
        <!-- Images -->
        @if (isNarrow) {
          <h2 class="g-col-12">
            {{ get(imageAndTextRow, 'image_and_text.image_and_text[0].header', '') }}
          </h2>
        }
        <div
          class="g-col-12 g-col-lg-6 d-flex flex-row align-items-center"
          [class.justify-content-center]="isNarrow"
          id="button-row-image-container"
          >
          @if (imageAndTextRow?.image_and_text?.image_and_text[0]?.enable_image_enlargement == true) {
            <app-image-zoom
              id="button-row-image"
              class="w-100"
                    [image]="
                        currentButtonRowImage !== ''
                            ? currentButtonRowImage
                            : imageAndTextRow.image_and_text.image_and_text[0].button_row[0].button_image.href
                    "
                    [altText]="
                        currentButtonRowImage !== ''
                            ? currentButtonRowImageAlt
                            : imageAndTextRow.image_and_text.image_and_text[0].button_row[0].button_image.title
                    "
              [@imgChange]="currentButtonRowImage"
            ></app-image-zoom>
          }
          @if (imageAndTextRow?.image_and_text?.image_and_text[0]?.enable_image_enlargement !== true) {
            <img
              id="button-row-image"
              class="mw-100"
              #buttonRowImageElement
                    [src]="
                        currentButtonRowImage !== ''
                            ? currentButtonRowImage
                            : imageAndTextRow.image_and_text.image_and_text[0].button_row[0].button_image.href
                    "
                    [alt]="
                        currentButtonRowImage !== ''
                            ? currentButtonRowImageAlt
                            : imageAndTextRow.image_and_text.image_and_text[0].button_row[0].button_image.title
                    "
              [@imgChange]="currentButtonRowImage"
              />
          }
        </div>
        <!-- Buttons -->
        @if (!get(imageAndTextRow, 'image_and_text.image_and_text[0].text')) {
          <div
            id="button-row-and-text-container"
            class="g-col-12 g-col-lg-6 d-flex flex-column justify-content-center"
            >
            @if (!isNarrow) {
              <h2>{{ get(imageAndTextRow, 'image_and_text.image_and_text[0].header', '') }}</h2>
            }
            <div class="button-row-container">
              <div class="button-row-margins">
                @for (button of get(imageAndTextRow, 'image_and_text.image_and_text[0].button_row', []); track button; let i = $index) {
                  <button
                    class="button button-gradient button-row-button"
                    id="{{ 'button-' + i }}"
                    [class.active]="'button-' + i === activeButtonId || (i === 0 && activeButtonId === '')"
                    (click)="setActiveButtonAndImage(i, button.button_image.href)"
                    >
                    {{ button.button_text }}
                  </button>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Dynamic accordion -->
  @if (!isEmpty(get(imageAndTextRow, 'image_and_text.image_and_text[0].accordion', false))) {
    <div
      class="container-padless d-flex flex-row flex-wrap"
      [class.flex-row-reverse]="get(imageAndTextRow, 'image_and_text.image_and_text[0].style', '') === 'Image on the right'"
      [class.justify-content-center]="isNarrow"
      >
      @if (!isNarrow) {
        <div class="accordion-image-container col-md-6">
          <img
            class="accordion-image"
            #accordionImage
            [src]="currentImage !== '' ? currentImage : imageAndTextRow?.image_and_text?.image_and_text[0]?.accordion[0]?.accordion_image?.href"
            />
          </div>
        }
        <div [id]="'dynamicAccordion-' + uniqueIndex" class="accordion col-xs-12 col-lg-6 dynamic-accordion-container">
          <div class="image-and-text-accordion-text">
            <h5 class="accordion-label mb-base">
              {{ get(imageAndTextRow, 'image_and_text.image_and_text[0].label', []) }}
            </h5>
            <h2 class="accordion-title">{{ get(imageAndTextRow, 'image_and_text.image_and_text[0].header', []) }}</h2>
            @if (get(imageAndTextRow, 'image_and_text.image_and_text[0].text', [])) {
              <div
                [innerHTML]="get(imageAndTextRow, 'image_and_text.image_and_text[0].text', '') | safe: 'html'"
              ></div>
            }
          </div>
          @for (accordion of get(imageAndTextRow, 'image_and_text.image_and_text[0].accordion', []); track accordion; let i = $index) {
            <div
              class="accordion-item"
              id="{{ 'accordion-item-' + uniqueIndex + i }}"
              (click)="setAccordion(i)"
              >
              <div class="accordion-header" id="{{ 'headingImageAndText-' + uniqueIndex + i }}">
                <div role="button" [attr.aria-expanded]="i === currentAccordion" class="accordion-button" [class.collapsed]="i !== currentAccordion" type="button"
                     tabindex="0"
                     (keydown.enter)="setAccordion(i); $event.preventDefault()"
                     (keydown.space)="setAccordion(i); $event.preventDefault()">
                  <label class="check-icon" for="rd1"
                    ><div class="horizontal"></div>
                    @if (i !== currentAccordion) {
                      <div class="vertical"></div
                        >
                    }</label>
                    <span>{{ accordion?.accordion_title }}</span>
                  </div>
                </div>
                <div id="{{ 'collapseImageAndText-' + uniqueIndex + i }}" class="accordion-collapse collapse" [class.show]="i === currentAccordion">
                  <div class="accordion-body">
                    @if (isNarrow) {
                      <div class="accordion-image-container col-xs-12 col-lg-6 px-0">
                        <img
                          class="accordion-image"
                          #accordionImage
                                [src]="
                                    currentImage !== ''
                                        ? currentImage
                                        : imageAndTextRow?.image_and_text?.image_and_text[0]?.accordion[0]?.accordion_image?.href
                                "
                          />
                        </div>
                      }
                      <div [innerHTML]="accordion?.accordion_copy | safe: 'html'"></div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </section>
      @if (get(imageAndTextRow, 'image_and_text.split_line', '')) {
        <hr class="m-0 mb-3" />
      }
